const { itemFetcherToArrayGetter, genericGetter } = require("./utilities")
const { gql } = require("@apollo/client")

const DataLoader = require("dataloader")

function batchPropGetter(obj) {
  return async function (keys) {
    const response = await obj.client.query({
      query: gql`
            {
                thing(id:"${obj.id}"){
                    id
                    ${keys.join("\n")}
                }
            }
        `,
    })

    const fetchedValues = keys.map((key) => response.data.thing[key])

    return fetchedValues
  }
}

class Thing {
  constructor(client, id) {
    this.client = client
    this.id = id
    this.propLoader = new DataLoader(batchPropGetter(this))
  }

  static fields() {
    return [
      "id",
      "index",
      "createdAt",
      "updatedAt",
      "myRole",
      "paired",
      "producer",
      "starred",
      "type",
      "name",
      "variableCount",
      "variables",
      "environment",
      "notifications",
      "lastNotification",
      "notificationCount",
      "online",
      "storageUsed",
      "diskUsed",
      "bandwidthUsed",
      "signalStatus",
      "batteryStatus",
      "batteryCharging",
      "firmware",
      "muted",
      "pairCode",
      "qrCode",
    ]
  }

  get index() {
    return this.propLoader.load("index")
  }

  get createdAt() {
    return this.propLoader.load("createdAt")
  }

  get updatedAt() {
    return this.propLoader.load("updatedAt")
  }

  get myRole() {
    return this.propLoader.load("myRole")
  }

  get paired() {
    return this.propLoader.load("paired")
  }

  get starred() {
    return this.propLoader.load("starred")
  }

  get type() {
    return this.propLoader.load("type")
  }

  get name() {
    return this.propLoader.load("name")
  }

  get variableCount() {
    return this.propLoader.load("variableCount")
  }

  variables(options) {
    const { getVariable } = require("./variable")

    const sortBy = options ? options.sortBy : undefined
    const sortDirection = options ? options.sortDirection : undefined
    const filter = options ? options.filter : undefined

    return itemFetcherToArrayGetter(
      getVariable(this.id, sortBy, sortDirection, filter),
      this.client
    )
  }

  get notifications() {
    const { getNotification } = require("./notification")
    return itemFetcherToArrayGetter(getNotification(this.id), this.client)
  }

  get notificationCount() {
    return this.propLoader.load("notificationCount")
  }

  get online() {
    return this.propLoader.load("online")
  }

  get storageUsed() {
    return this.propLoader.load("storageUsed")
  }

  get diskUsed() {
    return this.propLoader.load("diskUsed")
  }

  get bandwidthUsed() {
    return this.propLoader.load("bandwidthUsed")
  }

  get signalStatus() {
    return this.propLoader.load("signalStatus")
  }

  get batteryStatus() {
    return this.propLoader.load("batteryStatus")
  }

  get batteryCharging() {
    return this.propLoader.load("batteryCharging")
  }

  get firmware() {
    return this.propLoader.load("firmware")
  }

  get muted() {
    return this.propLoader.load("muted")
  }

  get pairCode() {
    return this.propLoader.load("pairCode")
  }

  get qrCode() {
    return this.propLoader.load("qrCode")
  }
}

const getThing = (environmentId, sortBy, sortDirection, filter) =>
  genericGetter(
    async (index) =>
      gql(`
{
    environment(id:"${await environmentId}") {
        id
        things(offset:${index},limit:1, ${sortBy ? "sortBy: " + sortBy : ""}, ${
        sortDirection ? "sortDirection: " + sortDirection : ""
      }, ${
        filter
          ? "filter: " +
            JSON.stringify(filter).replace(/\"([^(\")"]+)\":/g, "$1:")
          : ""
      }){
            id
        }
    }
}
`),
    "environment.things",
    Thing
  )

const getDeveloperThing = (sortBy, sortDirection, filter) =>
  genericGetter(
    async (index) =>
      gql(`
  {
      user {
          id
          developerThings(offset:${index},limit:1, ${
        sortBy ? "sortBy: " + sortBy : ""
      }, ${sortDirection ? "sortDirection: " + sortDirection : ""}, ${
        filter
          ? "filter: " +
            JSON.stringify(filter).replace(/\"([^(\")"]+)\":/g, "$1:")
          : ""
      }){
              id
          }
      }
  }
  `),
    "user.developerThings",
    Thing
  )

module.exports = { Thing, getThing, getDeveloperThing }
